/**
 * Enchantress. "Whenever you cast a spell, you may animate target
 * aura until your next turn. It's an aura minion with power equal to
 * its cost."
 *
 * The on-cast watcher entry lives in `public/sorcery-cards-automation.json`
 * keyed by "Enchantress." `on_spell_cast` trigger, `self_controller`
 * scope, `animate_target_aura` op. GameBoard's `_fireOnSpellCast`
 * pipeline walks every card on the board after a Magic spell commits
 * and dispatches matching entries; Enchantress's entry opens the
 * target picker for animatable auras and applies the transform.
 *
 * No avatar-rules fields beyond the defaults. The avatar's behaviour
 * is entirely encoded in its automation JSON. This file exists so the
 * registry knows Enchantress is a recognised avatar (consistent with
 * Harbinger and other automation-only avatars).
 */
export const ENCHANTRESS_RULES = {};
